

















import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import GeneralSettingsMixin from "../../mixins/http/GeneralSettingsMixin";
import InlineMultiSelect from "@/components/InlineMultiSelect.vue";

@Component({ components: { InlineMultiSelect } })
export default class GeneralSettingMultiselect extends Mixins(
  GeneralSettingsMixin
) {
  @Prop() readonly idSelected!: string | number | undefined;
  @Prop({ default: () => [] }) value!: any[] | null;
  @Prop() readonly params!: any;
  @Prop() readonly formClass?: string;
  @Prop() readonly searchEnabled?: boolean;
  @Prop() readonly classes?: string;
  @Prop() readonly dataKeys?: Array<string>;
  @Prop() readonly placeholder?: string;
  @Prop({ default: false }) readonly actsLikeFilter?: boolean;
  @Prop({ required: false }) readonly queryKey?: string;
  @Prop({ default: true }) readonly preselect!: boolean;
  @Prop() readonly type?: string;

  private items: any = [];
  private id: any = this.idSelected || null;

  private filter = { ...this.params };

  get queryParams() {
    return { ...this.params };
  }

  mounted() {
    this.loadItems();
  }

  onSearch(obj) {
    this.filter.name = obj;
    this.loadItems();
  }

  onDataUpdated(data) {
    this.$emit("change", data);
  }

  onItemSelected(data) {
    this.$emit("change", data);
  }

  get tag() {
    return `get_${this.type}_tag`;
  }

  loadItems() {
    this.getSettings(this.type, { filter: { ...this.filter } }, this.tag).then(
      (resp) => {
        this.items = resp.map((o) => {
          return { id: o.id, name: o.fullName };
        });
      }
    );
  }

  onItemsReady() {
    if (this.idSelected) {
      this.id = this.idSelected;
    } else {
      if (this.preselect) {
        this.id =
          this.queryKey && this.$route.query[this.queryKey]
            ? this.$route.query[this.queryKey]
            : this.items[0]?.id;
      }
    }
  }

  // loadItems() {
  //   this.getCities({ filter: { ...this.filter } }, GeneralSettingMultiselect.getGeneralSettingTag).then(
  //     resp => {

  //       this.items = resp.map(o => {
  //         return { id: o.id, name: o.name };
  //       });
  //       if (this.actsLikeFilter) {
  //         this.items.unshift(this.all);
  //       }
  //       if (this.idSelected) {
  //         this.id = this.idSelected;
  //       } else {
  //         if(this.preselect){
  //         this.id =
  //           this.queryKey && this.$route.query[this.queryKey]
  //             ? this.$route.query[this.queryKey]
  //             : this.items[0]?.id;
  //       }
  //       }

  //     },
  //     err => {}
  //   );
  // }
}
